import { Check } from 'lucide-react';
import type { InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';

import { cn } from '../../lib/utils';

export function Select({ className, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      className={cn(
        'h-11 w-full rounded-lg border bg-surface px-3 text-sm text-foreground',
        'focus-visible:border-accent',
        className,
      )}
      {...props}
    />
  );
}

export function Textarea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      className={cn(
        'min-h-24 w-full rounded-lg border bg-surface px-3 py-2 text-sm text-foreground',
        'placeholder:text-muted focus-visible:border-accent',
        className,
      )}
      {...props}
    />
  );
}

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

/** Native checkbox with a drawn box, so it keeps keyboard behaviour. */
export function Checkbox({ label, className, ...props }: CheckboxProps) {
  return (
    <label className={cn('inline-flex cursor-pointer items-center gap-2 text-sm', className)}>
      <span className="relative inline-grid size-5 place-items-center">
        <input
          type="checkbox"
          className="peer size-5 appearance-none rounded border bg-surface checked:border-accent checked:bg-accent"
          {...props}
        />
        <Check className="pointer-events-none absolute size-3.5 text-accent-foreground opacity-0 peer-checked:opacity-100" />
      </span>
      {label ? <span className="text-foreground">{label}</span> : null}
    </label>
  );
}
